import React, { Component } from "react";
import Picker from "react-mobile-picker";
import { CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import {
  Card,
  Button,
  CardBody,
  Row,
  Modal,
  ModalBody,
  ModalHeader,
  Col,
  ModalFooter,
  CardFooter,
  Progress,
  ButtonGroup,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Spinner,
  UncontrolledTooltip,
  CardHeader,
  Label,
  ButtonDropdown,
} from "reactstrap";
import { connect } from "react-redux";
import Proptypes from "prop-types";
import Select from "react-select";
import "react-select/dist/react-select.css";
import moment from "moment";
import { withRouter } from "react-router";
import { Link } from "react-router-dom";
import ReactHtmlParser from "react-html-parser";
import {
  destroyKasms,
  getUserKasms,
  createKasms,
  getStatusKasms,
  updateKeepalive,
  getUserImages,
  getViewedKasms,
} from "../../../../actions/actionDashboard";
import { logout } from "../../../../actions/actionLogin";
import { NotificationManager } from "react-notifications";
import LoadingSpinner from "../../../../components/LoadingSpinner/index";
import { getUserUsageSummary } from "../../../../actions/actionUser";
import emptyState from "../../../../../assets/images/emptyState.png";
import livekasmbg from "../../../../../assets/images/livekasmbg.png";
import opera from "../../../../../assets/images/opera.svg";
import cross from "../../../../../assets/images/cross.png";
import rightArrow from "../../../../../assets/images/right-arrow.png";
import downArrow from "../../../../../assets/images/downArrow.svg";
import Image from "./image";
var intervalID;
const categories = [
  {
    id: "all",
    label: "All Workspaces",
    isActive: true,
  },
  {
    id: "productivity",
    label: "Productivity",
    isActive: false,
  },
  {
    id: "development",
    label: "Development",
    isActive: false,
  },
  {
    id: "games",
    label: "Games",
    isActive: false,
  },
];
// let optionGroups
let initialCategories = null;
class Listkasms extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      deleteConfirm: null,
      videoQuality: window.localStorage.getItem("video_quality") ? JSON.parse(window.localStorage.getItem("video_quality")) : 1,
      kasmId: "",
      deleteKasmName: "",
      deleteKasmImage: "",
      currentId: null,
      url: "",
      activeCard: false,
      loader: false,
      attempt: 0,
      progressBarValues: [],
      pointPresenceValues: [],
      persistentProfileValues: [],
      zoneSelections: {},
      networkSelections: {},
      refreshing: false,
      showTips: true,
      toggleControlPanel: false,
      createClicked: false,
      createResumeClicked: false,
      disconnect: false,
      deleteClicked: false,
      dropdownOpen: false,
      categories: [],
      availableKasms: [],
      selectedCategory: categories[0],
      isLaunchModal: false,
      zoneDropDown: false,
      isShowCategories: false,
      appToLaunch: null,
      selectedKasmData: {},
      valueGroups: {},
      optionGroups: {},
      isPickerShow: false,
      searchTerm: "",
      searchText: "",
    };
    this.deleteConfirm = this.deleteConfirm.bind(this);
    this.destroyKasms = this.destroyKasms.bind(this);
    this.initializePointsofPresence = this.initializePointsofPresence.bind(
      this
    );
    this.initializePersistentProfile = this.initializePersistentProfile.bind(
      this
    );
    this.initializeZones = this.initializeZones.bind(this);
    this.initializeNetworks = this.initializeNetworks.bind(this);
    this.renderLiveKasms = this.renderLiveKasms.bind(this);
    this.renderAvailableKasms = this.renderAvailableKasms.bind(this);
    this.toggle = this.toggle.bind(this);
    this.toggleCard = this.toggleCard.bind(this);
    this.createKasm = this.createKasm.bind(this);
    this.handlePointPresenceDropDown = this.handlePointPresenceDropDown.bind(
      this
    );
    this.handlePersistentProfileDropDown = this.handlePersistentProfileDropDown.bind(
      this
    );
    this.handleResumeKasm = this.handleResumeKasm.bind(this);
    this.stateFunctionUrl = this.stateFunctionUrl.bind(this);
    this.toggleDrop = this.toggleDrop.bind(this);
    this.updateProgressBarValue = this.updateProgressBarValue.bind(this);
    this.handleDisconnect = this.handleDisconnect.bind(this);
    this.defaultThumb = this.defaultThumb.bind(this);
    this.renderJoinedKasms = this.renderJoinedKasms.bind(this);
    this.toggleDropDown = this.toggleDropDown.bind(this);
    this.launchModal = this.launchModal.bind(this);
    this.toggleZone = this.toggleZone.bind(this);
    this.toggleShowCategory = this.toggleShowCategory.bind(this);
    this.selectCategory = this.selectCategory.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.getOptions = this.getOptions.bind(this);
    this.togglePicker = this.togglePicker.bind(this);
    this.chooseCategory = this.chooseCategory.bind(this);
    this.getFilteredItems = this.getFilteredItems.bind(this);
  }

  togglePicker() {
    this.setState(({ isPickerShow }) => ({
      isPickerShow: !isPickerShow,
    }));
  }

  defaultThumb(e) {
    e.target.src = "img/favicon.png";
  }
  toggleZone() {
    this.setState({
      zoneDropDown: !this.state.zoneDropDown,
    });
  }
  toggleShowCategory() {
    this.setState({
      isShowCategories: !this.state.isShowCategories,
    });
  }
  getOptions() {
    const rawOptions =
      this.props.availableCategories &&
      this.props.availableCategories.length > 0
        ? this.props.availableCategories.map((el) => {
            return el;
          })
        : [];
    const options = ["All Workspaces", ...rawOptions];
    return { label: options };
  }

  launchModal(selectedData) {
    this.setState({
      isLaunchModal: !this.state.isLaunchModal,
      selectedKasmData: selectedData,
    });
  }

  // Update the value in response to user picking event
  handleChange(name, value) {
    this.setState(({ valueGroups }) => ({
      valueGroups: {
        ...valueGroups,
        [name]: value,
      },
    }));
  }

  getCategories() {
    const tmpAvailableCategories =
      this.props.availableCategories &&
      this.props.availableCategories.length > 0
        ? this.props.availableCategories.map((el) => {
            return { id: el, label: el };
          })
        : [];
        if (tmpAvailableCategories)
        {
          const categories = [
            {
              id: "all",
              label: "All Workspaces",
            },
            ...tmpAvailableCategories,
          ];
          return categories;
        }
  }

  selectCategory(index) {
    const cats = this.getCategories().slice();
    const selectedCategory = cats[index];
    const updatedCategories = cats.map((el, idx) => {
      if (idx === index) {
        return {
          ...el,
          isActive: true,
        };
      } else {
        return {
          ...el,
          isActive: false,
        };
      }
    });

    if (selectedCategory && selectedCategory.id !== "all") {
      const { availableKasms } = this.props || [];
      let filteredTabkasm = availableKasms.filter((kasm) => {
        return kasm.categories.includes(selectedCategory.label);
      });
      initialCategories = filteredTabkasm;

      this.setState({
        availableKasms: initialCategories,
        selectedCategory: selectedCategory,
      });
    } else {
      const { availableKasms } = this.props;
      this.setState({
        availableKasms: availableKasms,
        selectedCategory: selectedCategory,
      });
    }

    this.setState({
      categories: updatedCategories,
    });
    this.toggleShowCategory();
  }
  getFilteredItems(initialCategories, value) {
    const filteredkasm = initialCategories.filter((kasm) => {
      const title = kasm.friendly_name ? kasm.friendly_name.toLowerCase() : "";
      if (title.includes(value)) {
        return true;
      } else {
        const isfoundCat = kasm.categories.find((el) => {
          const item = el.toLowerCase();
          return item.includes(value);
        });
        if (isfoundCat) {
          return true;
        } else {
          return false;
        }
      }
    });
    return filteredkasm;
  }
  handleSearch(e) {
    const { availableKasms } = this.props;
    const value = e.target.value ? e.target.value.toLowerCase() : "";
    this.setState({ searchText: value });
    const { selectedCategory } = this.state;
    if (selectedCategory && selectedCategory.id !== "all") {
      // if (value) {
      //   const filteredkasm = this.getFilteredItems(initialCategories,value)
      //   this.setState({
      //     availableKasms: filteredkasm,
      //   });
      // } else {
      //   this.setState({
      //     availableKasms: initialCategories,
      //   });
      // }
    } else {
      if (value) {
        const filteredkasm = availableKasms.filter((kasm) => {
          const title = kasm.friendly_name
            ? kasm.friendly_name.toLowerCase()
            : "";
          if (title.includes(value)) {
            return true;
          } else {
            const isfoundCat = kasm.categories.find((el) => {
              const item = el.toLowerCase();
              return item.includes(value);
            });
            if (isfoundCat) {
              return true;
            } else {
              return false;
            }
          }
        });
        this.setState({
          availableKasms: filteredkasm,
        });
      } else {
        const { availableKasms } = this.props;
        this.setState({
          availableKasms: availableKasms,
        });
      }
    }
  }

  stateFunctionUrl() {
    this.setState({ url: "" });
  }

  deleteConfirm(event, kasm) {
    event.stopPropagation();
    this.setState({ modal: !this.state.modal, kasmId: kasm.kasm_id,  deleteKasmName: kasm.image.friendly_name, deleteKasmImage: kasm.image.image_src});
  }

  handleDisconnect() {
    this.stateFunctionUrl();
    this.setState({
      attempt: 0,
      showTips: false,
      disconnect: true,
    });
    this.delay_check_load();
  }

  toggleDropDown() {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen,
    });
  }

  handleResumeKasm(kasm_id) {
    const userInfo = JSON.parse(window.localStorage.user_info);
    const { getstatuskasmsError } = this.props;

    this.setState({ kasmId: kasm_id, createResumeClicked: true });
    this.props
      .getStatusKasms(kasm_id)
      .then(() => this.props.history.push("/kasm/" + kasm_id))
      .catch(
        () => this.setState({ kasmId: kasm_id, createResumeClicked: false }),
        "Unable to Fetch API Data"
      );
  }

  destroyKasms() {
    this.setState({
      deleteClicked: true,
    });

    this.props
      .destroyKasms(this.state.kasmId)
      .then(() => this.handleDeleteSuccess())
      .catch(() => this.handleDeleteError());
  }

  toggle() {
    this.setState({ modal: !this.state.modal });
  }

  handlePointPresenceDropDown(imageId, value) {
    let pointPresenceValues = this.state.pointPresenceValues;
    pointPresenceValues.map((image) => {
      if (image.imageId === imageId) {
        image.value = value;
      }
    });
    this.setState({ pointPresenceValues });
  }

  handlePersistentProfileDropDown(imageId, value) {
    let persistentProfileValues = this.state.persistentProfileValues;
    persistentProfileValues.map((image) => {
      if (image.imageId === imageId) {
        image.value = value;
      }
    });
    this.setState({ persistentProfileValues });
  }

  handleZoneDropDown(imageId, value) {
    let zoneSelections = this.state.zoneSelections;

    zoneSelections[imageId] = value;
    this.setState({ zoneSelections: zoneSelections });
  }

  handleNetworksDropDown(imageId, value) {
    let networkSelections = this.state.networkSelections;

    networkSelections[imageId] = value;
    this.setState({ networkSelections: networkSelections });
  }

  toggleCard() {
    this.state({ card3: !this.state.card3 });
  }

  handleDeleteSuccess() {
    const { destroyKasmsErrorMessage } = this.props;
    if (destroyKasmsErrorMessage) {
      NotificationManager.error(destroyKasmsErrorMessage, "Delete Session", 3000);
    } else {
      const userInfo = JSON.parse(window.localStorage.user_info);
      const payload_data = {
        token: userInfo.token,
        username: userInfo.username,
      };
      this.setState({ modal: false, deleteClicked: false });
      this.props.getUserKasms(payload_data);
      this.props.getUserUsageSummary();
      NotificationManager.success(
        "Successfully Deleted Kasm",
        "Delete Kasm",
        3000
      );
    }
  }

  createKasm(imageId, available) {
    if (!available) {
      NotificationManager.error(
        "This image is not currently available. Agent may still be downloading Image.",
        "Image Loading",
        3000
      );
      return;
    }

    this.setState({ currentId: imageId, createClicked: true });
    let currentImage = this.state.pointPresenceValues.find(
      (image) => image.imageId === imageId
    );
    let currentImage2 = this.state.persistentProfileValues.find(
      (image) => image.imageId === imageId
    );
    let selectedZone = this.state.zoneSelections[imageId];
    let selectedNetwork = this.state.networkSelections[imageId];
    let persistent_profile_mode =
      currentImage2 && currentImage2.value ? currentImage2.value.value : "";
    window.localStorage.setItem(
      "persistent_profile_mode",
      persistent_profile_mode
    );
    this.props
      .createKasms({
        point_of_presence:
          currentImage && currentImage.value ? currentImage.value.value : "",
        persistent_profile_mode: persistent_profile_mode,
        image_id: imageId,
        x_res: window.innerWidth,
        y_res: window.innerHeight,
        zone_id: selectedZone && selectedZone.value ? selectedZone.value : "",
        network_id: selectedNetwork && selectedNetwork.value ? selectedNetwork.value : "",
      })
      .then(() => {
        this.handleCreateSuccess();
      })
      .catch(() => this.handleCreateError());
  }

  handleDeleteError() {
    const { deleteKasmsError } = this.props;
    this.setState({ createClicked: false, deleteClicked: false });
    if (deleteKasmsError) {
      NotificationManager.error(deleteKasmsError, "Delete Session", 3000);
    } else {
      NotificationManager.error("Failed to Delete Session", "Delete Session", 3000);
    }
  }

  handleCreateError() {
    const { createKasmsError, errorCreateMessageDetail } = this.props;
    this.setState({ createClicked: false });
    if (createKasmsError) {
      NotificationManager.error(createKasmsError, "Create Session", 3000);
      if (errorCreateMessageDetail) {
        console.error(errorCreateMessageDetail);
      }
    } else {
      NotificationManager.error("Gateway Time-out", "Create Session", 3000);
    }
  }

  handleCreateSuccess() {
    const { errorCreateMessage, errorCreateMessageDetail } = this.props;
    if (errorCreateMessage) {
      NotificationManager.error(errorCreateMessage, "Create Kasm", 3000);
      this.setState({ createClicked: false });
      if (errorCreateMessageDetail) {
        console.error(errorCreateMessageDetail);
      }
    } else {
      NotificationManager.success("Kasm Created", "Successfully Created Kasm");
      const { createdKasms, getStatusKasms } = this.props;
      if (createdKasms.kasm_id) {
        this.props.history.push("/kasm/" + createdKasms.kasm_id);
      }
    }
  }

  toggleDrop(index) {
    index === this.state.activeCard
      ? this.setState({ activeCard: null })
      : this.setState({ activeCard: index });
  }

  updateProgressBarValue() {
    let dataCopy = [];
    const self = this;
    this.props.liveKasms &&
      this.props.liveKasms.length > 0 &&
      this.props.liveKasms.map((kasm) => {
        const now = new Date();
        const utc = new Date(now.getTime() + now.getTimezoneOffset() * 60000);
        const start_date = new Date(kasm.start_date);
        const end_date = new Date(kasm.expiration_date);
        let seconds = (end_date - start_date) / 1000;
        dataCopy.push({
          current_time: (utc - start_date) / 1000,
          expiry_time: seconds,
        });
      });

    intervalID = setInterval(function () {
      dataCopy.map((item, index) => {
        dataCopy[index].current_time = item.current_time + 1;
      });
      // FIXME KASM-365. Setting the state causes the full page to be re-rendered
      self.setState({ progressBarValues: dataCopy });
    }, 1000);
  }

  initializePointsofPresence(availableKasms) {
    let pointPresenceValues = [];
    availableKasms.map((kasm) =>
      pointPresenceValues.push({ imageId: kasm.image_id, value: "" })
    );
    this.setState({ pointPresenceValues });
  }

  initializePersistentProfile(availableKasms) {
    let persistentProfileValues = [];

    let cached_persistent_profile_mode = window.localStorage.getItem(
      "persistent_profile_mode"
    );
    if (
      !cached_persistent_profile_mode ||
      (cached_persistent_profile_mode &&
        cached_persistent_profile_mode != "Disabled")
    ) {
      cached_persistent_profile_mode = "Enabled";
    }

    availableKasms.map((kasm) =>
      persistentProfileValues.push({
        imageId: kasm.image_id,
        value: {
          key: cached_persistent_profile_mode,
          value: cached_persistent_profile_mode,
        },
      })
    );
    this.setState({ persistentProfileValues });
  }

  initializeZones(availableKasms) {
    let zoneSelections = {};

    availableKasms.map((kasm) => (zoneSelections[kasm.image_id] = ""));
    this.setState({ zoneSelections: zoneSelections });
  }

  initializeNetworks(availableKasms) {
    let networkSelections = {};

    availableKasms.map((kasm) => (networkSelections[kasm.image_id] = ""));
    this.setState({ networkSelections: networkSelections });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.availableKasms) {
      const categoryIndex =
        this.state.categories &&
        this.state.categories.findIndex((el, index) => {
          return (
            this.state.selectedCategory &&
            this.state.selectedCategory.id === el.id
          );
        });
      this.selectCategory(categoryIndex);
      const newArray =
        this.state.availableKasms && this.state.availableKasms.length > 0
          ? this.state.availableKasms
          : this.props.availableKasms;
      this.setState({
        availableKasms: newArray,
      });
    }

    if (
      this.props.availableKasms !== nextProps.availableKasms &&
      nextProps.availableKasms &&
      nextProps.availableKasms.length > 0
    ) {
      this.initializePointsofPresence(nextProps.availableKasms);
      this.initializePersistentProfile(nextProps.availableKasms);
      this.initializeZones(nextProps.availableKasms);
      this.initializeNetworks(nextProps.availableKasms);
    }
  }

  componentWillUnmount() {
    //Stops memory leak from setInterval calls
    if (intervalID) {
      window.clearInterval(intervalID);
    }
  }

  componentDidMount() {
    if (window.localStorage.getItem("joined_kasms")) {
      let viewed_kasms = JSON.parse(window.localStorage.getItem("joined_kasms"))
        .kasms;
      this.props.getViewedKasms(viewed_kasms);
    }
    this.props.availableKasms &&
      this.initializePointsofPresence(this.props.availableKasms);
    this.props.availableKasms &&
      this.initializePersistentProfile(this.props.availableKasms);
    this.props.availableKasms &&
      this.initializeZones(this.props.availableKasms);
    this.props.availableKasms &&
      this.initializeNetworks(this.props.availableKasms);
    this.updateProgressBarValue(this.props.liveKasms);
    this.props.getUserUsageSummary();
    const availableCategories =
      this.props.availableCategories &&
      this.props.availableCategories.length > 0
        ? this.props.availableCategories.map((el) => {
            return { id: el, label: el, isActive: false };
          })
        : [];

    const options =
      this.props.availableCategories &&
      this.props.availableCategories.length > 0
        ? this.props.availableCategories.map((el) => {
            return el;
          })
        : [];
    this.setState({
      categories: [
        {
          id: "all",
          label: "All Workspaces",
          isActive: true,
        },
        ...availableCategories,
      ],
      availableKasms: this.props.availableKasms,
    });
  }
  componentDidUpdate(prevProps,prevState){
    if(prevProps.availableKasms!==this.props.availableKasms)
   {
     this.setState({ availableKasms: this.props.availableKasms})
   }

  }

  renderLiveKasms() {
    if (this.state.loader ) {
      return (
        <div>
          <div
            className={
              this.props.statusKasms &&
              this.props.statusKasms.is_persistent_profile
                ? "loaderStatus"
                : ""
            }
          >
            Loading Persistent Profile. This may take a moment...
          </div>
          <div className="loaderBg">
            {" "}
            <LoadingSpinner />
          </div>
        </div>
      );
    }
    const { liveKasms } = this.props;
    let doRefresh = false;

    // We want to refresh the Live Kasms data every so often if there is a delete_pending Kams. it should get cleaned up shortly after.
    if (liveKasms && liveKasms.length > 0) {
      for (let i in liveKasms) {
        if (liveKasms[i].operational_status === "delete_pending") {
          doRefresh = true;
        }
      }
    }
    if (doRefresh && !this.state.refreshing) {
      this.state.refreshing = true;
      setTimeout(() => {
        const userInfo = JSON.parse(window.localStorage.user_info);
        const payload_data = {
          token: userInfo.token,
          username: userInfo.username,
        };
        this.props.getUserKasms(payload_data);
        this.state.refreshing = false;
      }, 10000);
    }

    return (
      <div
        className={`running-apps ${
          liveKasms && liveKasms.length == 0 ? "hide-Apps" : ""
        }`}
      >
        <h3>
          Active Sessions
          <span className="badge badge-secondary">
            {liveKasms ? liveKasms.length : 0}
          </span>
        </h3>
        {liveKasms && liveKasms.length === 0 && (
          <div className="col-md-12 no-live-kasm text-center">
            <div className="col-md-12 mb-4">
              <img src={emptyState} alt="emptyState" />
            </div>
            <div className="col-md-12 content">
              <h5>Currently no apps are running!</h5>
              <p>
                You can manage running apps from this space once you launch them.
              </p>
            </div>
          </div>
        )}

        <div>
          {liveKasms && liveKasms.length > 0 ? (
            <div>
              <Row>
                <Col xs="12">
                  {liveKasms
                    .sort(function (a, b) {
                      return a.kasm_id.localeCompare(b.kasm_id);
                    })
                    .map((kasm, index) => {
                      const screenShot = kasm.kasm_id
                        ? `${__CLOUD_SERVER__}get_kasm_screenshot?kasm_id=${kasm.kasm_id}&width=1000&height=1000`
                        : livekasmbg;

                      return (
                        <Card className="mb-4 panelContainerBody" key={index}>
                          <div className="listkasm-active">
                            <div className="undo-background">
                              <CardBody
                                className={
                                  kasm.operational_status == "delete_pending"
                                    ? "text-white bg-danger"
                                    : "text-white"
                                }
                              >
                                <div className="d-flex align-items-center mb-4">
                                  {kasm.image &&
                                  kasm.image.image_src &&
                                  kasm.image &&
                                  kasm.image.image_src != "" ? (
                                    <img
                                      onError={(e) =>
                                        (e.target.style.display = "none")
                                      }
                                      className="livethumbnails"
                                      src={kasm.image.image_src}
                                    />
                                  ) : (
                                    <i className="fa fa-laptop bg-info p-2 font-2xl mr-3" />
                                  )}
                                  <h3 className="kasm_heading">
                                    {kasm.image.friendly_name}:{" "}
                                    {kasm.kasm_id &&
                                      kasm.kasm_id.substring(0, 6)}{" "}
                                  </h3>
                                </div>
                                <div className="kasmimg-hover">
                                  <div className="kasmimg-hover-div">
                                    {/* <img
                                    className="livekasmimg"
                                    src={ livekasmbg}
                                    alt="livekasmbg"
                                  /> */}
                                    <Image
                                      className="livekasmimg"
                                      src={screenShot ? screenShot : livekasmbg}
                                      alt="livekasmbg"
                                    />
                                  </div>
                                  {this.state.progressBarValues[index] ? (
                                    <Progress
                                      className="progress_kasm"
                                      value={
                                        this.state.progressBarValues[index]
                                          .current_time
                                      }
                                      min={0}
                                      max={
                                        this.state.progressBarValues[index]
                                          .expiry_time
                                      }
                                    />
                                  ) : (
                                    ""
                                  )}
                                  <div className="middle">
                                    <button
                                      className="text"
                                      onClick={() => {
                                        this.handleResumeKasm(kasm.kasm_id);
                                      }}
                                    >
                                      <i
                                        className="fa fa-play"
                                        aria-hidden="true"
                                      ></i>{" "}
                                      Resume
                                    </button>
                                    <button
                                      className="text delete"
                                      onClick={(event) =>
                                        this.deleteConfirm(event, kasm)
                                      }
                                    >
                                      <i
                                        className="fa fa-trash"
                                        aria-hidden="true"
                                        id={kasm.kasm_id}
                                      ></i>{" "}
                                      Delete
                                    </button>
                                  </div>
                                </div>
                              </CardBody>
                              <CardFooter className="kasm_footer pt-0">
                                <div className="d-flex time-wrapper">
                                  <div className="mr-lg-5 mr-4">
                                    <div className="uptime">Uptime</div>

                                    <div className="text-value">
                                      {moment
                                        .utc(kasm.current_time)
                                        .diff(
                                          moment.utc(kasm.start_date),
                                          "days"
                                        )
                                        ? moment
                                            .utc(kasm.current_time)
                                            .diff(
                                              moment.utc(kasm.start_date),
                                              "days"
                                            ) + "d "
                                        : ""}
                                      {moment
                                        .utc(kasm.current_time)
                                        .diff(
                                          moment.utc(kasm.start_date),
                                          "hours"
                                        )
                                        ? moment
                                            .utc(
                                              moment
                                                .utc(kasm.current_time)
                                                .diff(
                                                  moment.utc(kasm.start_date),
                                                  "hh:mm:ss"
                                                )
                                            )
                                            .format("HH[h] ")
                                        : ""}
                                      {moment
                                        .utc(
                                          moment
                                            .utc(kasm.current_time)
                                            .diff(
                                              moment.utc(kasm.start_date),
                                              "hh:mm:ss"
                                            )
                                        )
                                        .format("mm[m]")}
                                    </div>
                                  </div>
                                  <div>
                                    <div className="uptime">Expiring in</div>
                                    <div className="text-value">
                                      {moment.utc(kasm.expiration_date) <
                                      moment.utc(kasm.current_time) ? (
                                        <div>Expired</div>
                                      ) : moment
                                          .utc(kasm.expiration_date)
                                          .diff(
                                            moment.utc(kasm.current_time),
                                            "minutes"
                                          ) < 60 ? (
                                        <div>
                                          {moment
                                            .utc(
                                              moment
                                                .utc(kasm.expiration_date)
                                                .diff(
                                                  moment.utc(kasm.current_time),
                                                  "hh mm ss"
                                                )
                                            )
                                            .format("mm[m]")}
                                        </div>
                                      ) : (
                                        <div>
                                          {moment
                                            .utc(kasm.expiration_date)
                                            .diff(
                                              moment.utc(kasm.current_time),
                                              "days"
                                            )
                                            ? moment
                                                .utc(kasm.expiration_date)
                                                .diff(
                                                  moment.utc(kasm.current_time),
                                                  "days"
                                                ) + "d "
                                            : ""}
                                          {moment
                                            .utc(kasm.expiration_date)
                                            .diff(
                                              moment.utc(kasm.current_time),
                                              "hours"
                                            )
                                            ? moment
                                                .utc(
                                                  moment
                                                    .utc(kasm.expiration_date)
                                                    .diff(
                                                      moment.utc(
                                                        kasm.current_time
                                                      ),
                                                      "hh:mm:ss"
                                                    )
                                                )
                                                .format("HH[h] ")
                                            : ""}
                                          {moment
                                            .utc(
                                              moment
                                                .utc(kasm.expiration_date)
                                                .diff(
                                                  moment.utc(kasm.current_time),
                                                  "hh:mm:ss"
                                                )
                                            )
                                            .format("mm[m]")}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </CardFooter>
                            </div>
                          </div>
                        </Card>
                      );
                    })}
                </Col>
              </Row>
            </div>
          ) : null}
        </div>
      </div>
    );
  }

  chooseCategory() {
    this.togglePicker();
    const value = this.state.valueGroups.label;
    const cats = this.getCategories().slice();
    const selectedCategory = cats.find((el) => {
      return el.label.toLowerCase() === value.toLowerCase();
    });
    if (selectedCategory && selectedCategory.id !== "all") {
      const { availableKasms } = this.props || [];
      const filteredkasm = availableKasms.filter((kasm) => {
        return kasm.categories.includes(selectedCategory.label);
      });
      initialCategories = filteredkasm;
      this.setState({
        availableKasms: filteredkasm,
        selectedCategory: selectedCategory,
      });
    } else {
      const { availableKasms } = this.props;
      this.setState({
        availableKasms: availableKasms,
        selectedCategory: selectedCategory,
      });
    }
  }

  renderAvailableKasms() {
    if (this.state.loader  ) {
      return (
        <div className="loaderBg">
          {" "}
          <LoadingSpinner />
        </div>
      );
    }
    const { availableKasms, searchText } = this.state;
    const { persistentProfileValues, pointPresenceValues } = this.state;
    let keysSorted;
    let kasms =
      availableKasms && availableKasms.length > 0 ? [...availableKasms] : [];
    const lowerSearch = this.state.searchText.toLowerCase();
    if (searchText !== "") {
      kasms = kasms.filter((i) => {
        const category = i.categories.filter((i) =>
          i.toLowerCase().includes(lowerSearch)
        );
        return (
          i.friendly_name.toLowerCase().includes(lowerSearch) ||
          category.length > 0
        );
      });
    }

    return (
      <div className="panelbackground">
        {availableKasms && availableKasms.length > 0 ? (
          <div className="panelContainerBody panel">
            <Row>
              <Col xs="12">
                <div className="card-outer" key={this.state.selectedCategory && this.state.selectedCategory.label}>
                  {kasms
                    .sort(function (a, b) {
                      return a.friendly_name.localeCompare(b.friendly_name);
                    })
                    .map((kasm, index) => {
                      let currentImage =
                        pointPresenceValues && pointPresenceValues.length > 0
                          ? pointPresenceValues.find(
                              (image) => image.imageId === kasm.image_id
                            )
                          : "";
                      let currentImage2 =
                        persistentProfileValues &&
                        persistentProfileValues.length > 0
                          ? persistentProfileValues.find(
                              (image) => image.imageId === kasm.image_id
                            )
                          : null;
                      if (kasm.enabled === true) {
                        return (
                          <div
                            className="card-inner"
                            key={index}
                            style={{ margin: "0 25px" }}
                          >
                            <div
                              className="kasmCardBottom"
                              onClick={() => this.launchModal(kasm)}
                              >
                              {kasm.available ? (
                                ""
                              ) : (
                                <span className="warning-icon">
                                  <i
                                    id={kasm.friendly_name.replace(
                                      /\s+/g,
                                      ""
                                    )}
                                    className="fa fa-exclamation-triangle text-danger font-2xl"
                                  />
                                  <UncontrolledTooltip
                                    target={kasm.friendly_name.replace(
                                      /\s+/g,
                                      ""
                                    )}
                                  >
                                    This Image has not been detected on an Agent. It may still be downloading.
                                    Refresh this page to check the status again or contact an Administrator.
                                  </UncontrolledTooltip>
                                </span>
                              )}
                              <div className="show-grid kasmCardContent">
                                <div
                                  className="kasmcard-img"
                                  xs={5}
                                  sm={4}
                                  md={3}
                                  lg={4}
                                  xl={4}
                                >
                                  {kasm.image_src && kasm.image_src != "" ? (
                                    <img
                                      onError={this.defaultThumb}
                                      className=" "
                                      src={kasm.image_src}
                                    />
                                  ) : (
                                    <i className="fa fa-laptop bg-info p-3 font-2xl" />
                                  )}
                                </div>
                                <div
                                  className="kasmcard-detail"
                                  className="settingPad"
                                >
                                  <h5 className="text-info">
                                    {kasm.friendly_name}
                                  </h5>
                                  <div className="text-muted">
                                    {this.state.selectedCategory &&
                                    !this.state.selectedCategory.label == "All"
                                      ? this.state.selectedCategory.label
                                      : kasm.default_category}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      } else {
                        return (
                          <div
                            className="card-inner image-disabled"
                            key={index}
                            style={{ margin: "0 25px" }}
                          >
                            <div
                              className="kasmCardBottom"
                              onClick={() => this.launchModal(kasm)}
                            >
                              {kasm.available ? (
                                ""
                              ) : (
                                <div>
                                  <span className="warning-icon">
                                    <i
                                      id={kasm.friendly_name.replace(
                                        /\s+/g,
                                        ""
                                      )}
                                      className="fa fa-exclamation-triangle text-danger font-2xl"
                                    />
                                    <UncontrolledTooltip
                                      target={kasm.friendly_name.replace(
                                        /\s+/g,
                                        ""
                                      )}
                                    >
                                      This Image has not been detected on an Agent. It may still be downloading.
                                      Refresh this page to check the status again or contact an Administrator.
                                    </UncontrolledTooltip>
                                  </span>
                                </div>
                              )}
                              <div className="show-grid kasmCardContent">
                                <div
                                  className="kasmcard-img"
                                  xs={5}
                                  sm={4}
                                  md={3}
                                  lg={4}
                                  xl={4}
                                >
                                  {kasm.image_src && kasm.image_src != "" ? (
                                    <img
                                      onError={this.defaultThumb}
                                      className=" "
                                      src={kasm.image_src}
                                    />
                                  ) : (
                                    <i className="fa fa-laptop bg-info p-3 font-2xl mr-3" />
                                  )}
                                </div>
                                <div
                                  className="kasmcard-detail"
                                  className="settingPad"
                                >
                                  <h5 className="text-info">
                                    {kasm.friendly_name}
                                  </h5>
                                  <div className="text-muted">
                                    {this.state.selectedCategory &&
                                    !this.state.selectedCategory.label == "All"
                                      ? this.state.selectedCategory.label
                                      : kasm.default_category}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      }
                    })}
                </div>
              </Col>
            </Row>
          </div>
        ) : (
          <div className="panelContainerBody"></div>
        )}
      </div>
    );
  }

  renderJoinedKasms() {
    const { viewedKasms, viewKasmsLoading } = this.props;
    if (viewKasmsLoading) {
      return <div>loading...</div>;
    }
    let recent_kasms =
      viewedKasms &&
      viewedKasms.map((kasm, i) => {
        return (
          <Col md="5" xl={3} className="join-shared-kasm" key={i}>
            <Link style={{ color: "black" }} to={"/join/" + kasm.share_id}>
              <Card className={"join-shared-kasm-card"}>
                <Row>
                  <div>
                    {kasm.image_src && kasm.image_src !== "" ? (
                      <img
                        onError={this.defaultThumb}
                        className="thumbnails float-left"
                        src={kasm.image_src}
                      />
                    ) : (
                      <i className="fa fa-laptop bg-info p-3 font-2xl mr-3 float-left" />
                    )}
                  </div>
                  <div style={{ paddingLeft: "10px" }}>
                    <h5 className="text-info"> {kasm.image}</h5>
                    Host: {kasm.user} <br />
                    Share ID: {kasm.share_id}
                  </div>
                </Row>
              </Card>
            </Link>
          </Col>
        );
      });
    return (
      <div className="panelContainer">
        <div className="panelContainerHeading">
          <i className="fa fa-align-justify" />{" "}
          <strong>Recently Viewed Sessions</strong>
        </div>
        <div className="panelContainerBody">
          <Row>{recent_kasms}</Row>
        </div>
      </div>
    );
  }

  render() {
    const { usageSummary, availableCategories, liveKasms } = this.props;
    let usage_duration = "";
    let usage_limit_start_date = "";
    let usage_limit_next_start_date = "";
    let color = "info";
    let interval = "";
    let interval_translation = {
      total: "",
      monthly: "This Month",
      weekly: "This Week",
      daily: "Today",
    };

    if (usageSummary && usageSummary.usage_limit_remaining) {
      let percent = 0;
      usage_limit_start_date = moment
        .utc(usageSummary.usage_limit_start_date)
        .local()
        .format("MM/DD/YY HH:mm");
      usage_limit_next_start_date = moment
        .utc(usageSummary.usage_limit_next_start_date)
        .local()
        .format("MM/DD/YY HH:mm");
      if (usageSummary.usage_limit_remaining > 0) {
        percent =
          100 -
          (usageSummary.usage_limit_remaining /
            usageSummary.usage_limit_hours) *
            100;
      } else {
        percent = 100;
      }

      if (percent > 90) {
        color = "danger";
      } else if (percent > 70) {
        color = "warning";
      } else {
        color = "info";
      }
    }

    if (usageSummary) {
      interval = interval_translation[usageSummary.usage_limit_interval];
      if (usageSummary.usage_limit_type === "per_group") {
        interval += ". Usage is shared with other group members.";
      }
    }

    const limitHours = (usageSummary && usageSummary.usage_limit_hours) || 0;
    const remainingHours =
    (usageSummary &&
      usageSummary.usage_limit_remaining &&
      usageSummary.usage_limit_remaining < 0
      ? 0
      : usageSummary &&
      usageSummary.usage_limit_remaining &&
      usageSummary.usage_limit_remaining.toFixed(1)) || 0;

    let percentage = ((limitHours - remainingHours) / limitHours) * 100;

    if (remainingHours === 0) percentage = 100;
    
    const isRed = percentage > 75 ? true : false;
    const isYellow = percentage > 50 && percentage <= 75 ? true : false;
    const isGreen = percentage > 0 && percentage <= 50 ? true : false;
    const categories = this.getCategories();
    const {
      selectedKasmData,
      pointPresenceValues,
      persistentProfileValues,
      valueGroups,
      isPickerShow,
    } = this.state;

    let currentImage =
      pointPresenceValues && pointPresenceValues.length > 0
        ? pointPresenceValues.find(
            (image) => image.imageId === selectedKasmData.image_id
          )
        : "";

    let currentImage2 =
      persistentProfileValues && persistentProfileValues.length > 0
        ? persistentProfileValues.find(
            (image) => image.imageId === selectedKasmData.image_id
          )
        : null;

    const optionGroups = this.getOptions();

    const maskStyle = {
      display: isPickerShow ? "block" : "none",
    };

    const pickerModalClass = `picker-modal${
      isPickerShow ? " picker-modal-toggle" : ""
    }`;

    return (
      <div className="kasm-outer">
        <Row>
        <div className={`left-section col-lg-${(liveKasms && liveKasms.length > 0) ? 8 : 9} p-0`}> 
            <div className="kasm-menubar">
              <nav className="navbar navbar-expand-lg navbar-light bg-light mt-0">
                <div className="toggler">
                  <div className="mobileSearch">
                    <input
                      type="text"
                      className="weui_select d-lg-none"
                      value={valueGroups.label || "select"}
                      readOnly
                      onClick={this.togglePicker}
                    />
                  </div>
                </div>
                <div
                  className={`collapse navbar-collapse ${
                    this.state.isShowCategories ? "show-categories" : ""
                  }`}
                >
                  <ul className="navbar-nav mr-auto">
                    {categories && categories.map((el, index) => {
                      return (
                        <li
                          className={`nav-item ${
                            this.state.selectedCategory &&
                            this.state.selectedCategory.id === el.id
                              ? "active"
                              : ""
                          }`}
                          key={el.id}
                          onClick={() => {
                            this.selectCategory(index);
                          }}
                        >
                          <a className="nav-link white-space-nowrap">
                            {el.label}
                          </a>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </nav>
              <div className="d-flex align-items-center px-4 search-wrapper">
                <form className="desk-search has-search my-2 my-lg-0">
                  <span className="fa fa-search form-control-feedback"></span>
                  <input
                    className="form-control mr-sm-2"
                    type="search"
                    placeholder="Search"
                    aria-label="Search"
                    onChange={this.handleSearch}
                  />
                </form>
              </div>
            </div>
            <div className="col-md-12">
              <form className="form-inline responsive-search has-search my-2 my-lg-0">
                <span className="fa fa-search form-control-feedback"></span>
                <input
                  className="form-control mr-sm-2"
                  type="search"
                  placeholder="Search"
                  aria-label="Search"
                  onChange={this.handleSearch}
                />
              </form>
            </div>

            <div>{this.renderAvailableKasms()}</div>
           {!categories && 
            <div className="loaderBg">
          {" "}
          <LoadingSpinner />
         </div>
             }
          </div>
          <div className="picker-modal-container">
            <div
              className="picker-modal-mask"
              style={maskStyle}
              onClick={this.togglePicker}
            ></div>
            <div className={pickerModalClass}>
              <header className="justify-content-end">
                <a href="javascript:;" onClick={this.chooseCategory}>
                  OK
                </a>
              </header>
              <Picker
                optionGroups={optionGroups || {}}
                valueGroups={valueGroups}
                onChange={this.handleChange}
              />
            </div>
          </div>

          <div className={`col-lg-${liveKasms && liveKasms.length > 0 ? 4 : 3} rightsection`}>
            <Row>
              <Col sm="12">
                {usageSummary &&
                usageSummary.group_metadata &&
                usageSummary.group_metadata.subscription_name ? (
                  <React.Fragment>
                    <Card className="hours-card">
                      <CardHeader>
                        <img
                          onError={this.defaultThumb}
                          className="livethumbnails float-left"
                          src={
                            usageSummary.group_metadata.subscription_thumbnail
                          }
                        />
                        <strong
                          style={{ verticalAlign: "-webkit-baseline-middle" }}
                        >
                          {usageSummary.group_metadata.subscription_name}
                        </strong>
                      </CardHeader>
                      <CardBody>
                        {usageSummary.group_metadata.subscription_description}
                      </CardBody>

                      {usageSummary.group_metadata.subscription_link &&
                      usageSummary.group_metadata.subscription_link_name ? (
                        <CardFooter className="kasm_footer">
                          <a
                            href={usageSummary.group_metadata.subscription_link}
                            rel="noopener noreferrer"
                            target="_blank"
                          >
                            {usageSummary.group_metadata.subscription_link_name}
                          </a>
                        </CardFooter>
                      ) : (
                        ""
                      )}
                    </Card>
                  </React.Fragment>
                ) : (
                  ""
                )}
              </Col>
            </Row>
            <Row className="mx-0">
              <Col sm="12" className="right-progressbar px-0">
                {usageSummary && usageSummary.usage_limit ? (
                  <React.Fragment>
                    <Card className="mb-0">
                      <CardBody>
                        <Row className="justify-content-center">
                          <Col md="8" lg="8">
                            <Row sm="12" xs="12" md="7">
                              <Col
                                xs="12"
                                sm="12"
                                className={`usage ${
                                  isRed
                                    ? "red-stroke"
                                    : isYellow
                                    ? "yellow-stroke"
                                    : isGreen
                                    ? "green-stroke"
                                    : ""
                                }`}
                                md="3"
                              >
                                <CircularProgressbar
                                  value={percentage && percentage.toFixed()}
                                  text={`${
                                    percentage && percentage.toFixed()
                                  }%`}
                                />
                              </Col>
                              <Col xs="12" sm="12" md="9">
                                <Label className="standalone-label">
                                  {" "}
                                  <u className="usage-text">
                                    {usageSummary.usage_limit_remaining &&
                                    usageSummary.usage_limit_remaining < 0
                                      ? usageSummary.usage_limit_hours
                                      : (
                                          usageSummary.usage_limit_hours -
                                          usageSummary.usage_limit_remaining
                                        ).toFixed(1)}
                                  </u>{" "}
                                  of{" "}
                                  <u className="usage-text">
                                    {usageSummary.usage_limit_hours}
                                  </u>{" "}
                                  <a href="/#/userprofile" style={{textDecoration: "none"}}>
                                    <span className="usage-text-border">
                                      Hours Used {interval}
                                    </span>
                                  </a>
                                </Label>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                  </React.Fragment>
                ) : (
                  ""
                )}
              </Col>
              <Col className="pl-0 pr-1">{this.renderLiveKasms()}</Col>
            </Row>
            {this.state.modal && (
              <Modal
                isOpen={this.state.modal}
                toggle={this.deleteConfirm}
                className={this.props.className}
                backdrop={true}
                toggle={this.toggle}
              >
                <ModalBody style={{maxHeight: "215px"}}>
                  <div className="modal-inner">
                    <div className="opera-box">
                      <div className="opera-box-img">
                        {this.state.deleteKasmImage != "" ? (
                          <img
                            onError={this.defaultThumb}
                            className=" "
                            src={this.state.deleteKasmImage}
                          />
                        ) : (
                          <i className="fa fa-laptop bg-info p-3 font-2xl mr-3 float-left" />
                        )}
                      </div>
                      <div className="opera-box-detail">
                        <div className="modal-item">
                          <h4>{this.state.deleteKasmName} </h4>
                          <button className="close-icon" onClick={this.toggle}>
                            <img src={cross} alt="close" />
                          </button>
                        </div>
                        <p className="opera-Productivity">
                          <span>Delete the currently running session</span>
                        </p>
                      </div>
                    </div>
                    <div style={{textAlign: "center"}}>
                    {this.state.deleteClicked ? (
                        <Spinner style={{ width: "64px", height: "64px", margin: "0 auto"}} color={"danger"} />
                      ) : (
                        <Button
                          onClick={this.destroyKasms}
                          disabled={this.props.destroyKasmsLoading}
                          className="destroy-button"
                          color="danger"
                        >
                          Delete
                        </Button>
                      )}
                    </div>
                  </div>
                </ModalBody>
              </Modal>
            )}
            {this.state.isLaunchModal && (
              <Modal
                centered
                className="launch-modal"
                isOpen={this.state.isLaunchModal}
                backdrop={true}
                toggle={this.launchModal}
              >
                <ModalBody>
                  <div className="modal-inner">
                    <div className="opera-box">
                      <div className="opera-box-img">
                        {selectedKasmData.image_src &&
                        selectedKasmData.image_src != "" ? (
                          <img
                            onError={this.defaultThumb}
                            className=" "
                            src={selectedKasmData.image_src}
                          />
                        ) : (
                          <i className="fa fa-laptop bg-info p-3 font-2xl mr-3 float-left" />
                        )}
                      </div>
                      <div className="opera-box-detail">
                        <div className="modal-item">
                          <h4>Launch {selectedKasmData.friendly_name} </h4>
                          <button className="close-icon" onClick={this.launchModal}>
                            <img src={cross} alt="close" />
                          </button>
                        </div>
                        <p className="opera-Productivity">
                          <span>{selectedKasmData.description}</span>
                        </p>
                      </div>
                    </div>
                    {selectedKasmData &&
                    selectedKasmData.persistent_profile_settings && selectedKasmData.enabled &&
                    selectedKasmData.persistent_profile_settings.length > 0 ? (
                      <div className="form-group">
                        <span className="label">Persistent Profile</span>
                        <Select
                          id={"persistent_profile_" + selectedKasmData.image_id}
                          key={selectedKasmData.image_id}
                          value={currentImage2 ? currentImage2.value : ""}
                          options={selectedKasmData.persistent_profile_settings.map(
                            (val) => {
                              return { key: val, value: val };
                            }
                          )}
                          valueKey="value"
                          labelKey="key"
                          name="image_id"
                          onChange={this.handlePersistentProfileDropDown.bind(
                            this,
                            selectedKasmData.image_id
                          )}
                        />
                      </div>
                    ) : (
                      ""
                    )}

                    {selectedKasmData &&
                    selectedKasmData.zones && selectedKasmData.enabled &&
                    selectedKasmData.zones.length > 0 ? (
                      <div className="form-group">
                        <span className="label">Deployment Zone</span>
                        <Select
                          id={"zone_" + selectedKasmData.image_id}
                          key={selectedKasmData.image_id}
                          value={
                            this.state.zoneSelections[selectedKasmData.image_id]
                          }
                          options={selectedKasmData.zones.map((val) => {
                            return { key: val.zone_name, value: val.zone_id };
                          })}
                          valueKey="value"
                          labelKey="key"
                          name="image_id"
                          onChange={this.handleZoneDropDown.bind(
                            this,
                            selectedKasmData.image_id
                          )}
                          clearable={false}
                        />
                      </div>
                    ) : (
                      ""
                    )}

                    {selectedKasmData &&
                    selectedKasmData.networks && selectedKasmData.enabled &&
                    selectedKasmData.networks.length > 0 ? (
                      <div className="form-group">
                        <span className="label">Network</span>
                        <Select
                          id={"zone_" + selectedKasmData.image_id}
                          key={selectedKasmData.image_id}
                          value={
                            this.state.networkSelections[selectedKasmData.image_id]
                          }
                          options={selectedKasmData.networks.map((val) => {
                            return { key: val.network_name, value: val.network_id };
                          })}
                          valueKey="value"
                          labelKey="key"
                          name="image_id"
                          onChange={this.handleNetworksDropDown.bind(
                            this,
                            selectedKasmData.image_id
                          )}
                          clearable={false}
                        />
                      </div>
                    ) : (
                      ""
                    )}

                    <Row className="kasmCardFooter">
                      {selectedKasmData.enabled === true ? (
                        <Col md="12">
                          <div>
                            {this.state.createClicked ? (
                              <div>
                                {" "}
                                {this.state.currentId ===
                                selectedKasmData.image_id ? (
                                  <Spinner
                                    color="primary"
                                    style={{ width: "64px", height: "64px" }}
                                  />
                                ) : (
                                  <Button
                                    color="primary"
                                    className="btn-block"
                                    style={{ cursor: "pointer" }}
                                    disabled={true}
                                  >
                                    Launch Session{" "}
                                    <img
                                      src={rightArrow}
                                      alt="rightArrow"
                                      className="ml-3"
                                    />
                                  </Button>
                                )}
                              </div>
                            ) : (
                              <Button
                                color="primary"
                                className="btn-block"
                                style={{ cursor: "pointer" }}
                                onClick={this.createKasm.bind(
                                  this,
                                  selectedKasmData.image_id,
                                  selectedKasmData.available
                                )}
                                disabled={
                                  selectedKasmData.available
                                    ? this.props.createKasmsLoading &&
                                      this.state.currentId ===
                                        selectedKasmData.image_id
                                    : false
                                }
                              >
                                {" "}
                                Launch Session{" "}
                                <img
                                  src={rightArrow}
                                  alt="rightArrow"
                                  className="ml-3"
                                />
                              </Button>
                            )}
                          </div>
                        </Col>
                      ) : (
                        <Col md="12">
                          <div>{ReactHtmlParser(this.props.disabledImageMessage)}</div>
                        </Col>
                      )}
                    </Row>
                  </div>
                </ModalBody>
              </Modal>
            )}
          </div>
        </Row>
      </div>
    );
  }
}

Listkasms.propTypes = {
  destroyKasms: Proptypes.func.isRequired,
  logout: Proptypes.func.isRequired,
  getUserKasms: Proptypes.func.isRequired,
  createKasms: Proptypes.func.isRequired,
  updateKeepalive: Proptypes.func.isRequired,
  getStatusKasms: Proptypes.func.isRequired,
  destroyKasmsErrorMessage: Proptypes.object,
  liveKasms: Proptypes.array,
  availableKasms: Proptypes.array,
  deleteKasmsError: Proptypes.object,
  errorCreateMessage: Proptypes.string,
  errorCreateMessageDetail: Proptypes.string,
  createKasmsError: Proptypes.string,
  createdKasms: Proptypes.object,
  statusKasms: Proptypes.object,
  getstatuskasmsError: Proptypes.object,
  errorStatusKasmsMessage: Proptypes.object,
  availableCategories: Proptypes.array,
  type: Proptypes.string,
  getstatuskasmsLoading: Proptypes.bool,
  destroyKasmsLoading: Proptypes.func,
  className: Proptypes.object,
  createKasmsLoading: Proptypes.bool,
  history: Proptypes.object.isRequired,
};

Listkasms = withRouter(Listkasms);

export default connect(
  (state) => ({
    errorCreateMessage: state.dashboard.errorCreateMessage || null,
    errorCreateMessageDetail: state.dashboard.errorCreateMessageDetail || null,
    deleteKasmsError: state.dashboard.deleteKasmsError || null,
    getstatuskasmsLoading: state.dashboard.getstatuskasmsLoading || null,
    destroyKasmsErrorMessage: state.dashboard.destroyKasmsErrorMessage || null,
    createKasmsLoading: state.dashboard.createKasmsLoading || false,
    destroyKasmsLoading: state.dashboard.destroyKasmsLoading || null,
    createKasmsError: state.dashboard.createKasmsError || null,
    statusKasms: state.dashboard.statusKasms || null,
    getstatuskasmsError: state.dashboard.getstatuskasmsError || null,
    errorStatusKasmsMessage: state.dashboard.errorStatusKasmsMessage || null,
    fetchedKasms: state.dashboard.kasms || [],
    createdKasms: state.dashboard.createdKasms || null,
    availableKasms: state.dashboard.availableKasms,
    availableCategories: state.dashboard.availableCategories,
    disabledImageMessage: state.dashboard.disabledImageMessage,
    liveKasms: state.dashboard.liveKasms,
    viewedKasms: state.dashboard.viewedKasms,
    viewKasmsLoading: state.dashboard.viewKasmsLoading,
    usageSummary: state.user.usageSummary,
  }),
  (dispatch) => ({
    logout: (logout_data) => dispatch(logout(logout_data)),
    imageFunc: (payload_data) => dispatch(getUserImages(payload_data)),
    destroyKasms: (data) => dispatch(destroyKasms(data)),
    getUserKasms: (payload_data) => dispatch(getUserKasms(payload_data)),
    createKasms: (data) => dispatch(createKasms(data)),
    updateKeepalive: (data) => dispatch(updateKeepalive(data)),
    getStatusKasms: (data) => dispatch(getStatusKasms(data)),
    getViewedKasms: (data) => dispatch(getViewedKasms(data)),
    getUserUsageSummary: (payload_data) => dispatch(getUserUsageSummary()),
  })
)(Listkasms);



// WEBPACK FOOTER //
// ./src/views/User/UserDashboard/ListKasms/index.js